import {conf} from '@ebexco/core/src/services/conf';
import {paramsReplacer} from '@ebexco/core/src/utils/params';
import {urlParams} from '@ebexco/core/src/utils/urls';

const isDevSplit = /-dev$/;

/**
 * @param {string} appName
 * @param {string} [featureKey]
 * @param {string} [feature]
 * @param {string} [urlTemplate]
 * @param {string} [urlTemplateTest]
 */
export function featureToggle(
  appName,
  featureKey = 'feature',
  feature = urlParams[featureKey] || conf[featureKey],
  urlTemplate = 'https://app.convincely.com/feature/:appName/:feature/',
  urlTemplateTest = 'https://app-test.convincely.com/:appName/:feature/',
) {
  const {featureToggles} = conf;

  if (feature) {
    if (feature === 'staging') {
      conf.baseUrl = paramsReplacer(urlTemplateTest, {appName, feature: 'integration'});
    } else if (featureToggles) {
      const [computedFeature, dev] = feature.split(isDevSplit);
      const isDev = dev === '';

      if (isDev) {
        feature = `feature/${feature}`;
      }

      if (computedFeature && featureToggles[computedFeature]) {
        conf.baseUrl = paramsReplacer(isDev ? urlTemplateTest : urlTemplate, {appName, feature});
      }
    }
  }
}
